import { HttpResponseBase } from '@angular/common/http';

export class HttpUtils {
	static getTraceId(response: HttpResponseBase): string {
		const header = response?.headers.get('x-trace');

		return header ? header.split(':')[0] : 'unknown';
	}
}
